window.addEventListener('DOMContentLoaded', () => {
    const getVideoHeight = setInterval(() => {
        const videoWrappers = document.querySelectorAll('.videoLibrary--video__wrapper');
        if (videoWrappers && videoWrappers.length > 0) {
            videoWrappers.forEach((videoWrapper) => {
                const videoPlayer = videoWrapper.querySelector('.videoLibrary--video__player');
                if (videoPlayer) {
                    const height = videoPlayer.videoHeight;
                    const width = videoPlayer.videoWidth;
                    if (height === 0 || width === 0) {
                        return;
                    } else {
                        getVideoFirstFrame();
                        clearInterval(getVideoHeight);
                    }
                }
            }
            )
        }
    }, 25);
    setTimeout(() => {
        clearInterval(getVideoHeight);
    }, 2000);
});

function getVideoFirstFrame() {
    const videoWrappers = document.querySelectorAll('.videoLibrary--video__wrapper');
    if (videoWrappers && videoWrappers.length > 0) {
        videoWrappers.forEach((videoWrapper) => {
            const videoThumbnail = videoWrapper.querySelector('.videoLibrary--video__thumbnail');
            const videoPlayer = videoWrapper.querySelector('.videoLibrary--video__player');
            const playIcon = videoWrapper.querySelector(".videoLibrary--video__image-container");
            if (videoPlayer) {
                let canvas = document.createElement('canvas');
                canvas.width = videoPlayer.videoWidth;
                canvas.height = videoPlayer.videoHeight;

                let ctx = canvas.getContext('2d');
                videoPlayer.preload = "auto";
                videoPlayer.load();
                videoPlayer.addEventListener('canplaythrough', () => {
                    ctx.drawImage(videoPlayer, 0, 0, canvas.width, canvas.height);
                    let dataUrl = canvas.toDataURL();
                    let img = new Image();
                    img.addEventListener('load', () => {
                        videoThumbnail.src = dataUrl;
                    });
                    img.src = dataUrl;
                });

                playIcon.addEventListener("click", () => {
                    playIcon.style.display = "none";
                    videoPlayer.style.display = 'block';
                    videoPlayer.play();
                    videoThumbnail.style.display = 'none';
                });
            }
        });
    }
}
